import { Card } from 'antd';
import type { PropsWithChildren } from 'react';
import { cn } from 'technical/tailwind/cn';

export const MainCard = ({
  children,
  smBottom = false,
}: PropsWithChildren<{ smBottom?: boolean }>) => {
  return (
    <Card className={cn('w-full px-4 pt-4', smBottom ? 'pb-2' : 'pb-4')}>
      {children}
    </Card>
  );
};
